import React from 'react';
import { useNavigate } from 'react-router-dom';

const TestNotFound = () => {
  const navigate = useNavigate();

  const goToNonExistentRoute = () => {
    // Navigate to a route that doesn't exist to trigger 404
    navigate('/this-route-does-not-exist');
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white p-8 rounded-lg shadow-lg max-w-md w-full">
        <h1 className="text-2xl font-bold mb-4">Test 404 Page</h1>
        <p className="text-gray-600 mb-6">
          Click the button below to navigate to a non-existent route and see the 404 page in action.
        </p>
        <button
          onClick={goToNonExistentRoute}
          className="w-full py-2 px-4 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-colors"
        >
          Go to Non-Existent Route
        </button>
      </div>
    </div>
  );
};

export default TestNotFound; 